export default "__VITE_ASSET__CzWhgYgS__"